webpackJsonp([191319344601756],{

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contactPageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n      font-size: ', '\n      margin-top: ', ';\n    '], ['\n      font-size: ', '\n      margin-top: ', ';\n    ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      font-size: calc(', ' * .9);\n    '], ['\n      font-size: calc(', ' * .9);\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      flex: 0 1 ', ';\n  '], ['\n      flex: 0 1 ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(49);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _HTMLtoJSX = __webpack_require__(77);
	
	var _HTMLtoJSX2 = _interopRequireDefault(_HTMLtoJSX);
	
	var _Styling = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	var TextArea = function (_React$Component) {
	  _inherits(TextArea, _React$Component);
	
	  function TextArea(props) {
	    _classCallCheck(this, TextArea);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.autoresize = _this.autoresize.bind(_this);
	    return _this;
	  }
	
	  TextArea.prototype.autoresize = function autoresize() {
	    this.textarea.style.height = 'auto';
	    this.textarea.style.height = this.textarea.scrollHeight + 'px';
	
	    this.textarea.scrollTop = this.textarea.scrollHeight;
	    window.scrollTo(window.scrollLeft, this.textarea.scrollTop + this.textarea.scrollHeight);
	  };
	
	  TextArea.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement('textarea', {
	      name: 'message',
	      rows: '1',
	      onChange: function onChange(e) {
	        _this2.autoresize();
	        _this2.props.onChange(e);
	      },
	      ref: function ref(textarea) {
	        _this2.textarea = textarea;
	      }
	    });
	  };
	
	  return TextArea;
	}(_react2.default.Component);
	
	var StyledForm = _styledComponents2.default.form.withConfig({
	  displayName: 'contact-page__StyledForm'
	})(['color:', ';font-family:', ';display:flex;flex-wrap:wrap;justify-content:space-between;margin:0 auto;margin-top:', ';', ';*{font-size:', ';', ';}input,textarea{border:none;-webkit-appearance:none;border-bottom:2px solid ', ';border-radius:0;display:block;margin-bottom:4.5rem;margin-right:auto;margin-left:auto;overflow:hidden;resize:none;width:100%;padding:0.1em;padding-bottom:0.3em;padding-top:1.5em;&:focus{outline:none;}}p{margin-right:auto;margin-left:auto;width:100%;}button{background:none;border:2px solid ', ';margin:0 auto;padding:0.8em 1.6em;transition:background-color 0.2s;&:hover{background:rgba(0,0,0,0.15);}&:focus,&:active{outline:none;}&:active{color:white;background:', ';}}'], _Styling.colors.black, _Styling.fonts.sans, _Styling.spacing[5], _Styling.mediaQueries.medium(_templateObject, _Styling.fontSizes[2], _Styling.spacing[6]), _Styling.fontSizes[2], _Styling.mediaQueries.medium(_templateObject2, _Styling.fontSizes[3]), _Styling.colors.black, _Styling.colors.black, _Styling.colors.black);
	
	var InputWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'contact-page__InputWrapper'
	})(['flex:1 1 100%;', ';'], _Styling.mediaQueries.medium(_templateObject3, function (props) {
	  return props.basis ? props.basis : 'auto';
	}));
	
	var ButtonWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'contact-page__ButtonWrapper'
	})(['text-align:center;width:100%;']);
	
	var Contact = function (_React$Component2) {
	  _inherits(Contact, _React$Component2);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this3 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	    _this3.handleChange = function (e) {
	      var _this3$setState;
	
	      _this3.setState((_this3$setState = {}, _this3$setState[e.target.name] = e.target.value, _this3$setState));
	    };
	
	    _this3.handleSubmit = function (e) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({ 'form-name': 'contact' }, _this3.state))
	      }).then(function () {
	        return alert('Success!');
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this3.state = {};
	    return _this3;
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Styling.PageWrapper,
	      { maxWidth: _Styling.Measures[2], style: this.props.transition && this.props.transition.style },
	      _react2.default.createElement(
	        _Styling.Heading,
	        null,
	        this.props.data.markdownRemark.frontmatter.title
	      ),
	      _react2.default.createElement(_HTMLtoJSX2.default, { content: this.props.data.markdownRemark.html }),
	      _react2.default.createElement(
	        StyledForm,
	        {
	          name: 'contact',
	          method: 'post',
	          'data-netlify': 'true',
	          'data-netlify-honeypot': 'bot-field',
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement(
	          InputWrapper,
	          { basis: '48%' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Name',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', name: 'name', onChange: this.handleChange })
	          )
	        ),
	        _react2.default.createElement(
	          InputWrapper,
	          { basis: '48%' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Email',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'email', name: 'email', onChange: this.handleChange })
	          )
	        ),
	        _react2.default.createElement(
	          InputWrapper,
	          { basis: '100%' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Message',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(TextArea, { onChange: this.handleChange })
	          )
	        ),
	        _react2.default.createElement(
	          ButtonWrapper,
	          null,
	          _react2.default.createElement(
	            'button',
	            { type: 'submit' },
	            'Send'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { hidden: true },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Don\u2019t fill this out: ',
	            _react2.default.createElement('input', { name: 'bot-field' })
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	var contactPageQuery = exports.contactPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-page-js-938c6940730fded2929f.js